import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Banner/banner.css';

export const AiDriven = () => {
    const [showUser, setShowUser] = useState(false);
    const [bannerData, setBannerData] = useState({ title: '', description: '', imageUrl: '' });

    // Fetch data from Strapi
    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_STRAPI_API_URL}/api/ai-drivens?populate=*`);
                const result = await response.json();
                if (result.data && result.data.length > 0) {
                    const { title, description, image } = result.data[0];
                    console.log(image);
                    const imageUrl = image?.url ? `${image.url}` : 'none';

                    console.log(imageUrl);
                    setBannerData({ title, description, imageUrl });
                }
            } catch (error) {
                console.error('Error fetching Strapi data:', error);
            }
        };

        fetchBannerData();
    }, []);

    // Check for username in sessionStorage
    useEffect(() => {
        if (sessionStorage.getItem('username')) {
            setShowUser(true);
        }
    }, []);

    return (
        <div className="newBanner">
            <div className="container">
                <div className="bannerBottom">
                    <div className="bannerBottomText">
                        <h3>{bannerData.title || 'AI-Driven Display Selector'}</h3>
                        <p>{bannerData.description || 'With AI technology, finding the best digital screens is easier than ever. Let us match you with displays that suit your goals perfectly.'}</p>
                        {showUser ? (
                            <Link to="/upload">Try Now</Link>
                        ) : (
                            <Link to="/signIn">Try Now</Link>
                        )}
                    </div>
                    <div>
                        <img src={bannerData.imageUrl} alt={bannerData.imageUrl} />
                    </div>
                </div>
            </div>
        </div>
    );
};